import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueLoading from 'vuejs-loading-plugin'

// Vue.use(VueLoading)

Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  background: 'rgb(255,255,255,0.6)', // set custom background
  classes: ['myclass'] // array, object or string
})


Vue.config.productionTip = false

Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
